import { BaseObserver } from '@journeyapps-labs/common-utils';
import { Crop } from '@foxbun/lib-goferal-types';

export interface MediaUploadListener {
  progressChanged: (percent: number) => any;
  finished: () => any;
}

export class MediaUpload extends BaseObserver<MediaUploadListener> {
  xhr: XMLHttpRequest;

  constructor(protected file: File) {
    super();
    this.xhr = new XMLHttpRequest();
    this.xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        this.iterateListeners((cb) => cb.progressChanged?.((event.loaded / event.total) * 100));
      }
    });
    this.xhr.addEventListener('loadend', (event) => {
      this.iterateListeners((cb) => cb.progressChanged?.(100));
    });

    this.xhr.onreadystatechange = () => {
      if (this.xhr.readyState === 4) {
        this.iterateListeners((cb) => cb.finished?.());
      }
    };
  }

  async send(url: string, token: string, crop?: Crop) {
    let url_ob = new URL(url);
    if (crop) {
      url_ob.searchParams.append('crop', JSON.stringify(crop));
    }

    this.xhr.open('POST', url_ob.toString(), true);
    this.xhr.setRequestHeader('Content-Type', 'application/octet-stream');
    this.xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    const formData = new FormData();
    formData.append('file', this.file);

    await new Promise<void>((resolve) => {
      let l1 = this.registerListener({
        finished: () => {
          l1();
          resolve();
        }
      });
      this.xhr.send(this.file);
    });
  }
}
